import React, { useState } from "react";
import "./layout.css";
import Navbarr from "../navbar/navbar";
import Footer from "../footer/footer";
// import { GetAllFilessAction } from "../../../redux/actions/FileAction";
// import { useDispatch } from "react-redux";
import { useEffect } from "react";
import Loader from "../../loader/loader";
import { GetuserNotificationNumberAction } from "../../../redux/actions/ManageAdminAction";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
const Layout = ({ userData, children, isAdmin, isUser, isEmp }) => {
  const location = useLocation();
  const notNumber = useSelector((state) => state.ManageAdminR.getNotnumber);
  const dispatch = useDispatch();
  // Call every 5 minutes
  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(GetuserNotificationNumberAction());
    }, 5 * 60 * 1000); // 5 minutes in milliseconds

    // Cleanup on unmount
    return () => clearInterval(intervalId);
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(GetuserNotificationNumberAction());
  // }, [location]);
  return (
    <div className="layout">
      <Navbarr
        userData={userData}
        isAdmin={isAdmin}
        isUser={isUser}
        isEmp={isEmp}
        notNumber={notNumber}
      />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
